export const POLL_STATES = {
  hide: 0,
  showQuestion: 1,
  showResult: 2,
  delete: 3,
};
